import { D12Mark } from "@/components/brand/d12-mark";

/** Two-tone wordmark: D12 in --ink at 600, Labs in --ink-subtle at 500. */
export function BrandLockup() {
	return (
		<a href="/" className="brand">
			<D12Mark labelled={false} />
			<span className="wordmark">
				D12 <i>Labs</i>
			</span>
		</a>
	);
}
